export {
  now,
  timer,
  timerFlush
} from "./src/timer";

export {
  default as timeout
} from "./src/timeout";

export {
  default as interval
} from "./src/interval";



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-timer/index.js
// module id = ../../../../d3-timer/index.js
// module chunks = 4